import { TServerErrorResponse, RoleAssignment } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const ROLE_ASSIGNMENT_GET = "role-assignment-get";

export const getRole = async () => {
  try {
    const response = await http.get<RoleAssignment>(links.roleAssignment.index);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getRoleAssignment = async (userId: string, roleId: string) => {
  try {
    const response = await http.get<RoleAssignment>(
      links.roleAssignment.roleAssignmentById(userId, roleId),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateRoleForUser = async (userId: string, roleId: string) => {
  try {
    const response = await http.put<RoleAssignment>(
      links.roleAssignment.roleAssignmentById(userId, roleId),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
